import { skipToken, useQuery } from "@tanstack/react-query";
import { baseApi } from "./baseApi";

export const usePostMarketPlaceFilterAuthors = (
  formData: any,
  page?: string,
  size?: string
) => {
  return useQuery({
    queryKey: ["market-place-filter-authous", page, size],
    queryFn:
      !page || !size || !formData
        ? skipToken
        : async () => {
            const response = await baseApi.post(
              `/marketplace_filter_authors?page=${page}&size=${size}`,
              formData, // Send FormData directly
              {
                headers: {
                  "Content-Type": "multipart/form-data", // Ensure it's treated correctly
                },
              }
            );
            return response;
          },
    retry: 0,
    staleTime: 3000,
  });
};

export const usePostMarketplaceFilterStrategies = (
  formData: any,
  page?: string,
  size?: string
) => {
  return useQuery({
    queryKey: ["marketplace-filter-strategies", page, size, formData],
    queryFn:
      !page || !size || !formData
        ? skipToken
        : async () => {
            const response = await baseApi.post(
              `/marketplace_filter_strategies?page=${page}&size=${size}`,
              formData, // Send FormData directly
              {
                headers: {
                  "Content-Type": "multipart/form-data", // Ensure it's treated correctly
                },
              }
            );
            return response;
          },
  });
};
